import { bindUrl, request } from "./request";
/**
 * 客户注册/重置验证码获取
 * POST /oil/client/code/fetch
 * @param {验证码获取} bodyParams - clientFetchCodeReq
 */
export function fetchCode(bodyParams) {
  return request({
    url: bindUrl("/blade-resource/sms/endpoint/send-login-code-captcha", {}),
    method: "POST",
    params: bodyParams
  });
}
/**
 * 客户详情
 * GET /oil/client/detail
 */
export function getClientDetail() {
  return request({
    url: bindUrl("/blade-user/information/accountInfo", {}),
    // url: bindUrl("/oil/app/client/detail", {}),
    method: "GET"
  });
}

export function informationSubmit(bodyParams) {
  return request({
    url: bindUrl("/blade-user/information/accountInfoSubmit", {}),
    method: "POST",
    data: bodyParams
  });
}

export function getRegionTree() {
  return request({
    // url: bindUrl("/blade-user/information/accountInfo", {}),
    url: bindUrl("/blade-system/region/lazy-tree", {}),
    method: "GET"
  });
}
/**
 * 客户登录
 * POST /oil/client/login
 * @param {客户登录} bodyParams - clientLoginReq
 */
export function login(bodyParams) {
  return request({
    url: bindUrl("/auth/oauth/token", {}),
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    params: bodyParams
  }).then(res => {
    try {
      window._czc.push(["_trackEvent", "操作", "登录"]);
    } catch (err) {
      console.log(err);
    }
    return Promise.resolve(res);
  });
}

/**
 * 客户登录
 * POST /oil/app/client/message/login
 * @param {客户登录} bodyParams - clientLoginReq
 */
export function messageLogin(bodyParams) {
  return request({
    url: bindUrl("/auth/oauth/token", {}),
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    params: bodyParams
  }).then(res => {
    try {
      window._czc.push(["_trackEvent", "操作", "登录"]);
    } catch (err) {
      console.log(err);
    }
    return Promise.resolve(res);
  });
}

/**
 * 客户登出
 * POST /oil/client/logout
 * @param {ClientLogoutReq} bodyParams - clientLogoutReq
 */
export function logout(bodyParams) {
  return request({
    url: bindUrl("/oil/app/client/logout", {}),
    method: "POST",
    data: bodyParams
  });
}
/**
 * 客户信息修改
 * POST /oil/client/modify
 * @param {客户信息修改} bodyParams - clientModifyReq
 */
export function modifyClient(bodyParams) {
  return request({
    url: bindUrl("/oil/app/client/modify", {}),
    method: "POST",
    data: bodyParams
  });
}
/**
 * 客户注册
 * POST /oil/client/register
 * @param {客户注册} bodyParams - clientRegisterReq
 */
export function registerClient(bodyParams) {
  return request({
    url: bindUrl("/oil/app/client/register", {}),
    method: "POST",
    data: bodyParams
  });
}

/**
 * 完善客户信息
 * POST /oil/client/perfect/information
 * @param {完善客户信息} bodyParams - clientPerfectInformationReq
 */
export function perfectInformation(bodyParams) {
  return request({
    url: bindUrl("/oil/app/client/perfect/information", {}),
    method: "POST",
    data: bodyParams
  });
}

/**
 * 身份证详情
 * POST /oil/client/idCard/detail
 */
export function getIdCardDetail() {
  return request({
    url: bindUrl("/oil/app/client/idCard/detail", {}),
    method: "POST"
  });
}
/**
 * 身份证上传
 * POST /oil/client/idCard/upload
 * @param {ClientUploadIdCardReq} bodyParams - clientUploadIdCardReq
 */
export function uploadIdCard(bodyParams) {
  return request({
    url: bindUrl("/oil/app/client/idCard/upload", {}),
    method: "POST",
    data: bodyParams
  });
}
/**存管会员注册验证码获取**/
export function codeFetch(bodyParams) {
  return request({
    url: bindUrl("/oil/app/client/bank/code/fetch", {}),
    method: "POST",
    data: bodyParams
  });
}
/**存管会员激活**/
export function bankMemberActive(bodyParams) {
  return request({
    url: bindUrl("/oil/app/client/bankMember/active", {}),
    method: "POST",
    data: bodyParams
  });
}

export function approve(bodyParams) {
  return request({
    url: bindUrl("/blade-user/approve/approve", {}),
    method: "POST",
    data: bodyParams
  });
}

export function approveInfo() {
  return request({
    url: bindUrl("/blade-user/approve/approveInfo", {}),
    // url: bindUrl("/oil/app/client/detail", {}),
    method: "GET"
  });
}

export function getMenuButtons() {
  return request({
    url: bindUrl("/blade-system/menu/buttons", {}),
    method: "GET"
  });
}

export function bindUser(id) {
  return request({
    url: bindUrl("/blade-user/social-binding?oauthId=" + id),
    method: "POST"
  });
}
